<app-table [data]="pendingToolRequests"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [isMaterial]="isMaterial"
           [headerBackgroundColor]="headerBackgroundColor"
           [hasTitle]="hasTitle"
           [showFilters]="showFilters"
           title="{{'lineSetter.pending-tool-requests.table.title' | translate}}"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'lineSetter.pending-tool-requests.table.columns.name' | translate}}
                                [{{'lineSetter.pending-tool-requests.table.columns.line' | translate}}_
                                {{'lineSetter.pending-tool-requests.table.columns.partNumber' | translate}}_
                                {{'lineSetter.pending-tool-requests.table.details-modal.createdDate' | translate }}]"
                      filterPlaceholder="{{'lineSetter.pending-tool-requests.table.filter.byName' | translate}}"
                      filter="true"
                      field="name"
                      sortable="true">
        <ng-template #body
                     let-toolRequest="rowData">
            <span>{{ toolRequest.name }}</span>
        </ng-template>
    </app-table-column>

    <app-table-column header="{{'lineSetter.pending-tool-requests.table.columns.creator' | translate}}"
                      filterPlaceholder="{{'lineSetter.pending-tool-requests.table.filter.byCreator' | translate}}"
                      filter="true"
                      field="createdBy"
                      sortable="true">
        <ng-template #body
                     let-toolRequest="rowData">
            <span>{{ toolRequest.createdBy.fullName }}</span>
        </ng-template>
    </app-table-column>
    <app-table-column header="{{'lineSetter.pending-tool-requests.table.columns.status' | translate}}"
                      sortable="true"
                      field="status">
        <ng-template #filter
                     let-column="column"
                     let-table="table">
            <app-dropdown [(ngModel)]="column.filterValue"
                          [items]="statusFilters"
                          valueField="value"
                          displayField="name"
                          emptyText="Status"
                          (selectItem)="table.onFilterChange(column)"></app-dropdown>
        </ng-template>
        <ng-template #body
                     let-tool="rowData">
            <span>{{ tool.status | translate }}</span>
        </ng-template>
    </app-table-column>
</app-table>
